import * as validator from "validator";

function sectionInit(element) {
  sectionsHeightInit(element);
  buttonsInit(element);
}

function sectionsHeightInit(element) {
  const heightStep1 = element.querySelector('.step1').clientHeight;
  const heightStep2 = element.querySelector('.step2').clientHeight;
  const heightStep3 = element.querySelector('.step3').clientHeight;
  const containerElement = element.querySelector('.container');

  containerElement.style.setProperty('--height', `${Math.max(heightStep1, heightStep2, heightStep3)}px`);
  containerElement.style.setProperty('height', `${Math.max(heightStep1, heightStep2, heightStep3)}px`);
}

function buttonsInit(element) {
  const container = element.querySelector('.container');
  const isStep3Visible = container.dataset.step3visible;
  const redirectTimeout = container.dataset.registertimeout;
  const registerSite = container.dataset.registersite;

  element.querySelector('.step1').querySelector('button').addEventListener('click', () => {
    handleButtonClick(element)
  });

  element.querySelector('.step2').querySelector('.sign-form').addEventListener('submit', (e) => {
    e.preventDefault();
    handleFormSubmit(element)
  });

  function handleButtonClick(element) {
    const animatedImagesElement = element.querySelector('.animated-step2');
    const videoElement = element.querySelector('.video-step2');

    handleStepChange(1, element);

    if (animatedImagesElement) {
      setTimeout(() => {
        initAnimation(animatedImagesElement);
      }, 1000);
    }

    if (videoElement) {
      setTimeout(() => {
        initAutoplay(videoElement);
      }, 500);
    }
  }

  function handleFormSubmit(element) {
    const emailElement = element.querySelector("input[type=text]");

    element.addEventListener("submit", (e) => {
      const emailValue = (emailElement.value + "").trim();

      if (!emailValue || !validator.isEmail(emailValue)) {
        e.preventDefault();
      } else {
        if (isStep3Visible) {
          const animatedImagesElement = element.querySelector('.animated-step3');
          const videoElement = element.querySelector('.video-step3');

          handleStepChange(2, element);

          if (animatedImagesElement) {
            setTimeout(() => {
              initAnimation(animatedImagesElement);
            }, 1000);
          }

          if (videoElement) {
            setTimeout(() => {
              initAutoplay(videoElement);
            }, 500);
          }

          setTimeout(() => {
            window.location.href = registerSite;
          }, redirectTimeout * 1000);
        } else {
          window.location.href = registerSite;
        }
      }
    });
  }

  function handleStepChange(stepIndex, element) {
    const step1Element = element.querySelector('.step1');
    const step2Element = element.querySelector('.step2');
    const step3Element = element.querySelector('.step3');

    if (stepIndex === 1) {
      step2Element.style.zIndex = '0';
      step2Element.style.opacity = '1';

      step1Element.style.zIndex = '-2';
      step1Element.style.opacity = '0';

      setTimeout(() => {
        step1Element.remove();
      }, 1000);
    } else if (stepIndex === 2) {
      step3Element.style.zIndex = '0';
      step3Element.style.opacity = '1';

      step2Element.style.zIndex = '-2';
      step2Element.style.opacity = '0';

      setTimeout(() => {
        step2Element.remove();
      }, 1000);
    }
  }
}

function initAnimation(element) {
  const transitionDuration = Number(element.dataset.transitiontime);
  const playMode = element.dataset.playmode;
  const images = element.querySelectorAll('img');
  const numberOfImages = element.querySelectorAll('img').length;

  let currentIndex = 0;
  let direction = 1;

  function imageAnimationHandler() {
    currentIndex = currentIndex + direction;
    const image = images[currentIndex];
    const displayTime = Number(image.dataset.displaytime);

    animation(element, currentIndex);

    if (currentIndex >= numberOfImages - 1 || currentIndex <= 0) {
      switch (playMode) {
        case 'infinite':
          if (!(currentIndex <= 0)) {
            currentIndex = -1;
          }
          break;
        case 'one-time':
          return;
        case 'boomerang':
          direction = direction * (-1);
          break;
        default:
          currentIndex = -1;
          break;
      }
    }

    setTimeout(imageAnimationHandler, (displayTime + transitionDuration) * 1000);
  }

  imageAnimationHandler();

}

function animation(element, currentIndex) {
  const images = element.querySelectorAll('img');
  const transitionDuration = element.dataset.transitiontime;

  images.forEach((image, idx) => {
    image.style.opacity = idx === currentIndex ? "1" : "0";
    image.style.transition = idx !== currentIndex ? `opacity ${transitionDuration}s ease` : 'none';

  })
}

function initAutoplay(element) {
  const playRepeat = element.dataset.playrepeat;
  const videoElement = element.querySelector('video');

  videoElement.addEventListener('play', () => {
    element.classList.remove('video-onClick');
  }, false);

  document.addEventListener('scroll', onScroll);

  switch (playRepeat) {
    case "once":
      videoElement.play();

      break;
    case "loop":
      const breakTime = element.dataset.breaktime;

      videoElement.play();
      videoElement.addEventListener('ended', loopHandler, false);

    function loopHandler() {
      setTimeout(function () {
        videoElement.play();
      }, breakTime * 1000);
    }

      break;
    default:
      break;
  }

  function onScroll() {
    if (!isInViewport(element)) {
      videoElement.pause();
      document.removeEventListener('scroll', onScroll);
      prepareVideo(element);
    }
  }

}

function isInViewport(element) {
  const rect = element.getBoundingClientRect();

  return rect.bottom - rect.height <= (window.innerHeight || document.documentElement.clientHeight) && rect.top + rect.height >= 0;
}

function prepareVideo(element) {
  if (!isInViewport(element)) {
    document.addEventListener('scroll', onScrollHandler);
  } else {
    initAutoplay(element);
  }

  function onScrollHandler() {
    if (isInViewport(element)) {
      initAutoplay(element);
      document.removeEventListener('scroll', onScrollHandler)
    }
  }
}

export function initHeaders() {
  document.querySelectorAll('.section-header').forEach(c => sectionInit(c));
}
